import axios from 'axios';
import baseService from '../shared/baseService';

const CompanyService = (spreadsheetId: number) =>
  baseService(`company/${spreadsheetId}`);

const getCompanyByClient = (clientId: number, params?: Record<string, any>) =>
  axios.get(`company/${clientId}/client`, { params });

const getCompanyById = (CompanyId: number, params?: Record<string, any>) =>
  axios.get(`company/${CompanyId}/profile`, { params });

const deleteCompanyById = (clientId: number, params?: Record<string, any>) =>
  axios.delete(`company/${clientId}/delete`, { params });

const putClassificationCompany = (clientId: number, params: any) =>
  axios.put(`company/${clientId}/classification`, params);

const putRevisorCompany = (clientId: number, params: any) =>
  axios.put(`company/${clientId}/revisor`, params);

export default {
  CompanyService,
  getCompanyByClient,
  getCompanyById,
  putRevisorCompany,
  putClassificationCompany,
  deleteCompanyById,
};
